import { UrlConstants } from "../url.constants";
export class ApiWorkflowConstants {
    static URL = UrlConstants.API_V2 + "Workflow";
    static FUNCTION_SAVE = "StepSave";
    static FUNCTION_CONTINUE = "StepContinue";
    static FUNCTION_AD_HOC_MOVE_TO_WORKFLOW_STEP = "AdHocMoveToWorkflowStep";
    static FUNCTION_GET_WORKFLOW_STEP_NAMES = "GetWorkflowStepNames";
    static FUNCTION_GET_STEP_META = "GetStepMeta";
    static FUNCTION_JOB_CURRENT_STEPS = "GetJobCurrentSteps";
    static FUNCTION_GET_ALL_MOVABLE_STEP_TYPES = "GetAllMovableStepTypes";
    static FUNCTION_MOVE_TO_WORKFLOW_STEP = "MoveToWorkflowStep";
    static FUNCTION_GET_JOB_TRACKER_DATA = "GetJobTrackerData";
    static FUNCTION_GET_JOB_WORKFLOW_IMAGE = "GetJobWorkflowImage";
    static FUNCTION_GET_STEP_TYPES = "GetStepTypes";
    static FUNCTION_FLUSH_CACHES = "FlushCaches";
    static FUNCTION_GET_ALL_STEP_TYPES = "GetAllStepTypes";
    static FUNCTION_SAVE_START = "StepSaveStart";
    static FUNCTION_CONTINUE_START = "StepContinueStart";
    static FUNCTION_SAVE_CREATE_INVOICE = "StepSaveCreateInvoice";
    static FUNCTION_CONTINUE_CREATE_INVOICE = "StepContinueCreateInvoice";
    static FUNCTION_SAVE_END = "StepSaveEnd";
    static FUNCTION_CONTINUE_END = "StepContinueEnd";
    static FUNCTION_SAVE_GEN_ASSIGN_RECIPIENT = "StepSaveGenAssignRecipient";
    static FUNCTION_CONTINUE_GEN_ASSIGN_RECIPIENT = "StepContinueGenAssignRecipient";
    static FUNCTION_SAVE_GEN_AWAIT = "StepSaveGenAwait";
    static FUNCTION_CONTINUE_GEN_AWAIT = "StepContinueGenAwait";
    static FUNCTION_SAVE_GEN_CAPTURE_ASSESSMENT = "StepSaveGenCaptureAssessment";
    static FUNCTION_CONTINUE_GEN_CAPTURE_ASSESSMENT = "StepContinueGenCaptureAssessment";
    static FUNCTION_SAVE_GEN_CAPTURE_PROOF_OF_PAYMENT = "StepSaveGenCaptureProofOfPayment";
    static FUNCTION_CONTINUE_GEN_CAPTURE_PROOF_OF_PAYMENT = "StepContinueGenCaptureProofOfPayment\"";
    static FUNCTION_SAVE_GEN_CAPTURE_RESULT = "StepSaveGenCaptureResult";
    static FUNCTION_CONTINUE_GEN_CAPTURE_RESULT = "StepContinueGenCaptureResult";
    static FUNCTION_SAVE_GEN_PLACEHOLDER = "StepSaveGenPlaceholder";
    static FUNCTION_CONTINUE_GEN_PLACEHOLDER = "StepContinueGenPlaceholder";
    static FUNCTION_SAVE_GEN_QUESTION = "StepSaveGenQuestion";
    static FUNCTION_CONTINUE_GEN_QUESTION = "StepContinueGenQuestion";
    static FUNCTION_SAVE_GEN_RECIEVE_COMMS = "StepSaveGenReceiveComms";
    static FUNCTION_CONTINUE_GEN_RECIEVE_COMMS = "StepContinueGenReceiveComms";
    static FUNCTION_SAVE_GEN_REPORT = "StepSaveGenReport";
    static FUNCTION_CONTINUE_GEN_REPORT = "StepContinueGenReport";
    static FUNCTION_SAVE_GEN_REQUEST_SURVEY_123 = "StepSaveGenRequestSurvey123";
    static FUNCTION_CONTINUE_GEN_REQUEST_SURVEY_123 = "StepContinueGenRequestSurvey123";
    static FUNCTION_SAVE_GEN_REQUEST_COMMENT = "StepSaveGenRequestComment";
    static FUNCTION_CONTINUE_GEN_REQUEST_COMMENT = "StepContinueGenRequestComment";
    static FUNCTION_SAVE_GEN_CAPTURE_COMMENT = "StepSaveGenCaptureComment";
    static FUNCTION_CONTINUE_GEN_CAPTURE_COMMENT = "StepContinueGenCaptureComment";
    static FUNCTION_SAVE_GEN_SEND_COMMS = "StepSaveGenSendComms";
    static FUNCTION_CONTINUE_GEN_SEND_COMMS = "StepContinueGenSendComms";
    static FUNCTION_SAVE_GEN_SET_CONDITIONS = "StepSaveGenSetConditions";
    static FUNCTION_CONTINUE_GEN_SET_CONDITIONS = "StepContinueGenSetConditions";
    static FUNCTION_SAVE_GEN_SET_FIELDS = "StepSaveGenSetFields";
    static FUNCTION_CONTINUE_GEN_SET_FIELDS = "StepContinueGenSetFields";
    static FUNCTION_SAVE_GEN_SET_GRAVE = "StepSaveGenSetGrave";
    static FUNCTION_CONTINUE_GEN_SET_GRAVE = "StepContinueGenSetGrave";
    static FUNCTION_SAVE_GEN_START_TIMEOUT = "StepSaveGenStartTimeout";
    static FUNCTION_CONTINUE_GEN_START_TIMEOUT = "StepContinueGenStartTimeout";
    static FUNCTION_SAVE_GEN_STOP_TIMEOUT = "StepSaveGenStopTimeout";
    static FUNCTION_CONTINUE_GEN_STOP_TIMEOUT = "StepContinueGenStopTimeout";
    static FUNCTION_SAVE_GEN_UPDATE_CHECKLIST = "StepSaveGenUpdateChecklist";
    static FUNCTION_CONTINUE_GEN_UPDATE_CHECKLIST = "StepContinueGenUpdateChecklist";
    static FUNCTION_SAVE_GEN_REQUIRED_DOCUMENTS_CHECKLIST = "StepSaveGenRequiredDocumentsChecklist";
    static FUNCTION_CONTINUE_GEN_REQUIRED_DOCUMENTS_CHECKLIST = "StepContinueGenRequiredDocumentsChecklist";
    static FUNCTION_SAVE_VERIFY_INVOICE = "StepSaveVerifyInvoice";
    static FUNCTION_CONTINUE_VERIFY_INVOICE = "StepContinueVerifyInvoice";
    static FUNCTION_GET_WORKFLOW_CLOSED_STATES = "GetWorkflowClosedStates";
    static FUNCTION_WITHDRAW_APPLICATION = "WithdrawApplication";
}
